import { render, staticRenderFns } from "./BotManageModerate.vue?vue&type=template&id=3b122726&"
import script from "./BotManageModerate.vue?vue&type=script&lang=js&"
export * from "./BotManageModerate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports